import React from "react";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import SearchInput from "components/inputs/search-input";
import { fetchCandidateResults } from "app/main/candidates/actions/candidates.actions";
import { getCandidateSearchTerms, getPageInfo } from "app/main/candidates/reducers/candidates.reducers";

class CandidatesSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = ({ searchParams }) => {
    const { pageInfo: { pageSize } } = this.props;
    this.props.fetchCandidateResults(1, pageSize, searchParams);
  };

  render() {
    const { initialValues } = this.props;
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        enableReinitialize
        render={({ handleSubmit }) => (
          <Field
            name="searchParams.name"
            component={SearchInput}
            onSearch={handleSubmit}
          />
        )}
      />
    );
  }
}

export default connect(state => ({
  pageInfo: getPageInfo(state),
  initialValues: { searchParams: getCandidateSearchTerms(state) },
}), { fetchCandidateResults })(CandidatesSearch);
